import React, { Children, cloneElement } from "react";
import PropTypes from "prop-types";
import find from "lodash.find";

const ErrorHandler = ({ type, types, errors, children }) => {
    if (!type && (!types || !types.length)) {
        return null;
    }

    const errorType = type || find(types, (t) => errors[t]);
    
    return (
        <div>
            { Children.map(children, (child) => cloneElement(child, { error: errors[errorType] })) }
        </div>
    );
};

ErrorHandler.propTypes = {
    type: PropTypes.string,
    types: PropTypes.arrayOf(PropTypes.string),
    errors: PropTypes.object.isRequired
};

export default ErrorHandler;
